import Head from 'next/head'
import { compose, setDisplayName } from 'recompose'

export interface OuterMetadataProps {}

interface InnerMetadataProps extends OuterMetadataProps {}

const enhance = compose<InnerMetadataProps, OuterMetadataProps>(setDisplayName('Metadata'))
export default enhance(() => (
  <Head>
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  </Head>
))
